export default {
  description: {
    default:
      'Download the Thanx app and get rewards automatically whenever you shop at merchants like %{merchantName}.',
    whitelabel:
      'Download the %{appName} app and get rewards automatically whenever you shop at %{merchantName}.',
  },
  title: 'Sign up for %{name} Rewards',
}
